<template>
    <div class="spmi-title border-l-2 border-[#02735F] pl-4 ml-4 *:flex-1 flex items-center">
        <h1 class="text-white fw-bold text-5xl sm:text-6xl md:text-7xl lg:text-[100px]">SPMI</h1>
    </div>
</template>